import { Stack, Text } from '@mantine/core';

interface ResultFieldProps {
  color?: string;
  label: string;
  value: React.ReactNode;
}

// Generic label-over-value tile shared by SummaryCard and ImpactCard so both surfaces render
// results with identical typography instead of duplicating the same markup.
export const ResultField: React.FC<ResultFieldProps> = ({ color, label, value }) => (
  <Stack gap={2}>
    <Text c="dimmed" fw={600} fz={11} lts={0.3} tt="uppercase">
      {label}
    </Text>
    <Text c={color} fw={600} fz="sm">
      {value}
    </Text>
  </Stack>
);
